import { useEffect } from 'react';

interface PreventOutsideScrollProps {
  enabled: boolean;
  elementRef: React.RefObject<HTMLElement>;

  /** Disables scroll bars for the document.body element */
  disableBodyScroll?: boolean;
}

export const usePreventOutsideScroll = ({ enabled, elementRef, disableBodyScroll }: PreventOutsideScrollProps) => {
  useEffect(() => {
    const preventScroll = (event: Event) => {
      if (!elementRef.current) {
        return;
      }

      const target = event.target as Node;
      if (elementRef.current.contains(target)) {
        return; // Allow scroll within the elementRef
      }

      event.preventDefault();
    };

    const subscribe = () => {
      document.addEventListener('wheel', preventScroll, { passive: false });
      document.addEventListener('touchmove', preventScroll, { passive: false });

      if (disableBodyScroll) {
        document.body.style.width = `${document.body.offsetWidth}px`;
        document.body.style.overflow = 'hidden';
      }
    };

    const unsubscribe = () => {
      document.removeEventListener('wheel', preventScroll);
      document.removeEventListener('touchmove', preventScroll);

      if (disableBodyScroll) {
        document.body.style.width = '';
        document.body.style.overflow = '';
      }
    };

    if (enabled) {
      subscribe();
    } else {
      unsubscribe();
    }

    return () => {
      unsubscribe();
    };
  }, [enabled, elementRef, disableBodyScroll]);
};
